import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { ConfigDto } from '../interfaces/config';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  private iCourrierURL: string;
  private config$: Observable<ConfigDto>;

  constructor(private http: HttpClient) {}

  /**
   * Fetches the global iCourrier configuration and caches it for the app lifetime (it rarely changes during a session).
   */
  public fetchConfig(): Observable<ConfigDto> {
    if (!this.config$) {
      this.config$ = this.http.get<ConfigDto>(`${this.iCourrierURL}/Global/Configuration`).pipe(shareReplay(1));
    }
    return this.config$;
  }

  public getLogoConfig(): Observable<Blob> {
    return this.http.get<Blob>(`${this.iCourrierURL}/Global/Configuration/Logo`, { responseType: 'blob' as 'json' });
  }

  load() {
    Object.assign(this, environment);
    this.iCourrierURL = environment?.apiICourrierBaseUrl;
    return environment;
  }
}
